module.exports = __webpack_public_path__ + "img/CM-MR-26-Ford-Modern.48bd65f9.jpg";